export const cibaWxEduLogin = (backUrl = window.location.href) => {
    const encode = window.encodeURIComponent
    const encodedCallbackUrl = encode(backUrl)
    const cb = encode(`https://edu-ciba.iciba.com/login?cb=${encodedCallbackUrl}`)
    const wxLoginUrl = encode(`https://course.iciba.com/course/weixin/redirect_login?url=${cb}`)
    const apiUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5042c286b62e8a1d&redirect_uri=${wxLoginUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`

    setTimeout(() => (window.location.href = apiUrl))
    return Promise.resolve({ msg: '跳转登录页面' })
}